import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'dialog-observations',
  templateUrl: './dialog-observations.component.html',
  styleUrls: ['./dialog-observations.component.scss']
})

export class DialogObservationsComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogObservationsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { observations: string }) { }

  ngOnInit() {

  }

  close() {
    this.dialogRef.close();
  }
  saveChanges() {
    this.dialogRef.close(this.data.observations);
  }

}
